import followMyHealthLogo from '../../../images/portal/retired-practice-message/followmyhealth.svg';

window.globalHelpersModule.directive "retiredPracticeMessage",
[->
  restrict: "E"

  scope:
    practiceName: '@'
    # 'patientInvite' / 'authorizedIndividualInvite' for pending-invite surfaces;
    # unset renders the general portal-retired wording.
    variant: '@'

  link: (scope) ->
    scope.followMyHealthLogo = followMyHealthLogo

  templateUrl: 'portal/retired-practice-message/retired-practice-message-directive-template.html'
]
